import { useState, useRef } from 'react'
import { initialEditorData, type EditorData } from './editorState'

interface Methods {
  insertNewNodes: (value: string) => void
  insertNodes: (value: any[]) => void  // 插入节点
  getEditorHTML: () => string
  insertHTML: (html: any, cover?: boolean) => any
  appendHTMLToBottom?: (html: string) => void
  [x: string]: (value: any) => void
}
const useEditorData = () => {
  const [editor, setEditor] = useState<any>()
  const [editorData, setEditorData] = useState<EditorData>(initialEditorData)
  const [methods, setMethods] = useState<Methods>()
  // 当editorArea内容改变时记录内容left值
  const [editorAreaLeft, setEditorAreaLeft] = useState(0)
  const methodsRef = useRef(methods)
  const changeMethods = (method: Methods) => {
    setMethods(method)
    methodsRef.current = method
  }

  // 初始化editor
  const initEditor = (editor: any) => {
    setEditor(editor)
  }
  
  return {
    editor,
    editorData,
    editorAreaLeft,
    setEditorAreaLeft,
    methods,
    setMethods: changeMethods,
    setEditorData,
    methodsRef,
    initEditor
  }
}

export default useEditorData
